import type { TechnologiesDescriptionDto } from "../../types/dto";
import { createDescriptionQuery } from "../options";
import { technologyQueryKeys } from "../queryKeyFactory";

import type { ITechnologyQueryClient, ITechnologyQueryClientDeps } from "./types";

export const createTechnologyQueryClient = ({ queryClient }: ITechnologyQueryClientDeps): ITechnologyQueryClient => {
    const descriptionOptions = createDescriptionQuery();

    return {
        getDescription: () => queryClient.fetchQuery<TechnologiesDescriptionDto>(descriptionOptions),

        getDescriptionFromCache: () =>
            queryClient.getQueryData<TechnologiesDescriptionDto>(technologyQueryKeys.description()),

        prefetchDescription: () => queryClient.prefetchQuery(descriptionOptions),

        invalidateDescription: () => queryClient.invalidateQueries({ queryKey: technologyQueryKeys.description() }),
    };
};
